import { makeStyles } from '@material-ui/core';
import icon from '../../assets/icon-kovi.svg';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 24,
  },
});

export const LogoIcon = () => {
  const classes = useStyles();
  return <img src={icon} alt="Kovi" className={classes.img} />;
};
